export default __webpack_public_path__ + "static/media/wunder-mobility-short.8e5cac84.svg";